module.exports = __webpack_public_path__ + "static/media/poll.0e701a2b.svg";